import { render, staticRenderFns } from "./Customer-list.vue?vue&type=template&id=02df2262&scoped=true&"
import script from "./Customer-list.vue?vue&type=script&lang=js&"
export * from "./Customer-list.vue?vue&type=script&lang=js&"
import style0 from "./Customer-list.vue?vue&type=style&index=0&id=02df2262&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02df2262",
  null
  
)

export default component.exports